import { InjectionToken } from '@angular/core';

/**
 * Chave do access token no `localStorage`.
 *
 * ⚠️ **Espelha o `AuthService` do app** (`localStorage.setItem('accessToken', …)`). Trocar a chave lá sem
 * trocar aqui faz o socket parar de autenticar **em silêncio** — o painel cai no polling e ninguém vê
 * erro. É por isso que existe teste amarrando este valor, e é por isso que o app pode sobrepor o
 * provedor abaixo em vez de depender desta constante.
 */
export const ACCESS_TOKEN_STORAGE_KEY = 'accessToken';

/**
 * De onde o transporte de realtime tira a credencial do handshake.
 *
 * É uma **função**, não um valor: o socket.io reconecta sozinho, e a cada tentativa o token precisa ser
 * relido. Guardar a string no momento da conexão faz o cliente reconectar para sempre com o token
 * velho — depois de um refresh de sessão, o realtime nunca mais volta, e o sintoma é "parou de
 * funcionar depois de um tempo".
 *
 * Vive no entrypoint **principal** da lib de propósito: assim o app pode sobrepor o provedor (para ler
 * do `AuthService`, por exemplo) sem importar o entrypoint do socket — que arrastaria `socket.io-client`
 * para o bundle inicial, inclusive o do cardápio público.
 */
export const REALTIME_ACCESS_TOKEN = new InjectionToken<() => string | undefined>('REALTIME_ACCESS_TOKEN', {
  providedIn: 'root',
  factory: () => () => localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY) || undefined,
});
